var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSchoolIcon = function SvgSchoolIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,5L5,15V35H35V15L20,5Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,35V25H25V35",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,10L10,17V20H30V17L20,10Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 27,
    width: 4,
    height: 8,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "20,5 22,5 22,1 25,1 21,1 20,1",
    fill: "#000000"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSchoolIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "school-icon.e5138e0a15bd2ab86c4b996e0796cf30.svg";